import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    filters: {
      display: 'flex',
      zIndex: 10
    },
    filter: {
      marginRight: theme.spacing(1),
      marginLeft: '-16px'
    },
    filterDisabled: {
      '& > .MuiChip-label': {
        color: '#999 !important'
      }
    }
  });
